import React, { useEffect, useRef, useState } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";

// REDUX
import { useSelector } from "react-redux";
// SERVICES
import { getOperationOrdersCoordinates } from "../../api/xRay";

const OrdersHeatMap = () => {
  const mapRef = useRef(null);

  const [heatmapData, setHeatmapData] = useState([]);

  const deliveryCenterLat = useSelector(
    (state) => state.deliveryCenter.deliveryCenter?.lat || 0
  );
  const deliveryCenterLng = useSelector(
    (state) => state.deliveryCenter.deliveryCenter?.lng || 0
  );

  useEffect(() => {
    const loadData = async () => {
      try {
        const { data } = await getOperationOrdersCoordinates();
        setHeatmapData(data);
      } catch (error) {
        console.error("Error loading data", error);
      }
    };

    loadData();
  }, []);

  useEffect(() => {
    if (heatmapData.length > 0 && mapRef.current) {
      const heat = L.heatLayer(heatmapData, { radius: 50 }).addTo(
        mapRef.current
      );
      return () => {
        mapRef.current.removeLayer(heat);
      };
    }
  }, [heatmapData]);

  return (
    <MapContainer
      center={[deliveryCenterLat, deliveryCenterLng]}
      minZoom={13}
      zoom={13}
      style={{ height: "100%", width: "100%" }}
      whenCreated={(map) => {
        mapRef.current = map;
      }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
    </MapContainer>
  );
};

export default OrdersHeatMap;
